function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export let DistributionTypes = /*#__PURE__*/function (DistributionTypes) {
  DistributionTypes["shipout"] = "shipout";
  DistributionTypes["giveaway"] = "giveaway";
  DistributionTypes["swagOrder"] = "swagOrder";
  DistributionTypes["storeOrder"] = "storeOrder";
  return DistributionTypes;
}({});
export let ProductTypes = /*#__PURE__*/function (ProductTypes) {
  ProductTypes["bundleProduct"] = "bundleProduct";
  ProductTypes["standardProduct"] = "standardProduct";
  return ProductTypes;
}({});
export let EnterpriseProductsTypes = /*#__PURE__*/function (EnterpriseProductsTypes) {
  EnterpriseProductsTypes["createCustomProducts"] = "createCustomProducts";
  return EnterpriseProductsTypes;
}({});
export const WarehouseEntities = _objectSpread({}, DistributionTypes, ProductTypes);
export const DistributionTypesNames = {
  [DistributionTypes.shipout]: 'Shipout',
  [DistributionTypes.giveaway]: 'Gift Giveaway',
  [DistributionTypes.swagOrder]: 'Swag order',
  [DistributionTypes.storeOrder]: 'Store order'
};
export let WeightMeasurement = /*#__PURE__*/function (WeightMeasurement) {
  WeightMeasurement["lbs"] = "lbs";
  return WeightMeasurement;
}({});
export let OrderPoweredBy = /*#__PURE__*/function (OrderPoweredBy) {
  OrderPoweredBy["Swag"] = "swag";
  OrderPoweredBy["SwagSpace"] = "swag-space";
  OrderPoweredBy["CustomInk"] = "custom-ink";
  return OrderPoweredBy;
}({});